import MainTitle from "components/general/MainTitle";
import Navbar from "components/navigation/Navbar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DEFAULT_TAB, EMAILING_TABS } from "./EmailingLayout.constants";
import "./EmailingLayout.css";
import { getTabByPath } from "./EmailingLayout.helpers";
import { TabsStyle, TabStyle } from "./EmailingLayout.style";

export function EmailingLayout() {
  const [selectedTab, setSelectedTab] = useState(DEFAULT_TAB);

  const { t } = useTranslation("emailing");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const newTab = getTabByPath(pathname);
    setSelectedTab(newTab);
  }, [pathname]);

  const handleChangeTabs = (path: string) => {
    const newTab = getTabByPath(path);
    navigate(path);
    setSelectedTab(newTab);
  };

  return (
    <div className="page-emailing">
      <Navbar />
      <div className="container-emailing">
        <MainTitle title={t(selectedTab.title)} />
        <TabsStyle
          value={selectedTab.path}
          onChange={(_, path) => handleChangeTabs(path)}
        >
          {EMAILING_TABS.map((tab) => (
            <TabStyle key={tab.path} value={tab.path} label={t(tab.label)} />
          ))}
        </TabsStyle>
        <div className="container-card">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
